import { render, staticRenderFns } from "./ConfidenceTag.vue?vue&type=template&id=2849ae0d&scoped=true"
import script from "./ConfidenceTag.vue?vue&type=script&lang=js"
export * from "./ConfidenceTag.vue?vue&type=script&lang=js"
import style0 from "./ConfidenceTag.vue?vue&type=style&index=0&id=2849ae0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2849ae0d",
  null
  
)

export default component.exports